<template lang="pug">
div(v-loading="loading").main
  el-card.margin.card-box(type="border-card", v-if="withTabs", shadow="hover")
    h3 {{ titulo }}
    el-row(:gutter="20")
      el-col(:xs="24" :md="12" :lg="6" :xl="6")
        p.label Período:
        el-date-picker.full-width.margin-bottom(
          v-bind="$attrs",
          type="daterange",
          unlink-panels,
          placeholder="Selecione",
          range-separator="a",
          format="dd/MM/yyyy",
          start-placeholder="Data Inicial",
          end-placeholder="Data Final",
          v-model="filtro.dateRange",
          name='prazo',
          :picker-options='options'
          @change="atualizarGraficos",
          :clearable="false"
        )

      el-col(:xs="24" :md="12" :lg="6" :xl="6" v-if="municipios")
        p.label Municípios:
        el-select.full-width.input(
          v-model="filtro.municipios",
          class="large-select",
          no-match-text="Nenhuma município encontrado",
          placeholder="Selecione municípios",
          name="municipios",
          @change="atualizarGraficos",
          multiple,
          collapse-tags,
          :clearable="true",
          value-key="id",
          :filterable="true",
          :reserve-keyword="true",
          :default-first-option="true"
        )
          el-option(
            v-for="item in municipios",
            :key="item.id",
            :label="item.nome",
            :value="item"
          )

        el-checkbox(
          v-model="selecionarTodos"
          @change="atualizarSelecionarTodosMunicipios"
        ) Selecionar todos

      el-col(:xs="24" :md="24" :lg="12" :xl="12", v-if="receitas.length")
        p.label Receitas:
        el-select.full-width.input(
          v-model="filtro.receitas",
          class="large-select",
          no-match-text="Nenhuma receita encontrada",
          placeholder="Selecione uma receita",
          name="receita",
          @change="atualizarGraficos",
          multiple,
          collapse-tags,
          :clearable="true",
          value-key="codigo",
          size="large",
          :filterable="true",
          :reserve-keyword="true",
          :default-first-option="true"
        )
          el-option(
            v-for="item in receitas",
            :key="item.codigo",
            :label="item.descricao",
            :value="item"
          )

    div.radioButton-container
      el-divider
        el-radio-group(v-model="tipoGraficoSelecionado" size="medium", @change="tabChange")
            el-radio-button(label="GRAFICO") Gráfico
            el-radio-button(label="TABELA") Tabela
    slot(name="grafico", v-if="tipoGraficoSelecionado === 'GRAFICO'")
    slot(name="tabela", v-if="tipoGraficoSelecionado === 'TABELA'")
    slot(name="pagination", v-if="tipoGraficoSelecionado === 'TABELA'")
    p.div-total(v-if="valorTotal && tipoGraficoSelecionado === 'GRAFICO'")
      b Valor total:
      | {{" " + valorTotal}}

  el-card.margin(type="border-card", shadow="hover" v-else).card-box
    h3 {{ titulo }}
    el-row(:gutter="20")
      el-col(:span="12")
        el-date-picker.full-width.margin-bottom(
          v-bind="$attrs",
          type="daterange",
          unlink-panels,
          placeholder="Selecione",
          range-separator="a",
          format="dd/MM/yyyy",
          start-placeholder="Data Inicial",
          end-placeholder="Data Final",
          v-model="filtro.dateRange",
          name='prazo',
          :picker-options='options',
          @change="atualizarGraficos",
          :clearable="false"
        )
    slot(name="grafico", v-show="!withTabs")
</template>

<script>
export default {
  props: {
    titulo: {
      type: String,
      required: true
    },
    withTabs: {
      type: Boolean,
      default: true
    },
    filtro: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    receitas: {
      type: Array
    },
    municipios: {
      type: Array
    },
    situacoes: {
      type: Array
    },
    valorTotal: {
      type: String
    },
    selecionarTodosMunicipios: {
      type: Boolean
    },
    selecionarTodasReceitas: {
      type: Boolean
    }
  },

  created () {
    this.selecionarTodos = this.selecionarTodosMunicipios

    if (this.selecionarTodosMunicipios) {
      this.filtro.municipios = this.municipios
    }

    if (this.selecionarTodasReceitas) {
      this.filtro.receitas = this.receitas
    }
  },

  data () {
    return {
      tipoGraficoSelecionado: 'GRAFICO',
      selecionarTodos: true,
      options: {
        shortcuts: [
          {
            text: 'Até Ontem',
            onClick (picker) {
              const end = new Date()
              const start = new Date('2019-1-1')
              end.setDate(end.getDate() - 1)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Últimos 7 dias',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - (3600 * 1000 * 24 * 7))
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Últimos 30 dias',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - (3600 * 1000 * 24 * 30))
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Este Mês',
            onClick (picker) {
              const end = new Date()
              const start = new Date(end.getUTCFullYear(), end.getMonth(), 1)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Último Mês',
            onClick (picker) {
              let start = new Date()
              let end = new Date()
              if (start.getMonth() === 0) {
                start = new Date(end.getUTCFullYear() - 1, 11, 1)
                end = new Date(end.getUTCFullYear() - 1, 12, 0)
              } else {
                start = new Date(end.getUTCFullYear(), end.getMonth() - 1, 1)
                end = new Date(end.getUTCFullYear(), end.getMonth(), 0)
              }
              picker.$emit('pick', [start, end])
            }
          }, {
            text: 'Último Ano',
            onClick (picker) {
              const date = new Date()
              const start = new Date(date.getUTCFullYear() - 1, 0, 1)
              const end = new Date(date.getUTCFullYear() - 1, 12, 0)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },

  methods: {
    atualizarSelecionarTodosMunicipios () {
      this.selecionarTodos = !this.selecionarTodos
      this.filtro.municipios = this.selecionarTodos ? this.municipios : []
      this.$emit('atualizarSelecionarTodosMunicipios', this.selecionarTodos)
    },

    atualizarGraficos () {
      this.$emit('gerarGraficos', this.tipoGraficoSelecionado)
    },

    tabChange (val) {
      this.$emit('tabChange', val)
    }
  }

}
</script>

<style lang="scss" scoped>
.titulo {
  color: #424242;
  font-weight: bold;
  font-size: 20px;
}

.margin {
  margin-top: 20px;
}

.full-width {
  width: 100%;
}

.margin-bottom {
  margin-bottom: 20px;
}

.div-total {
  padding: 2% 0 0 2%;
  font-size: 14px;
}

.card-box {
  border-radius: 12px;
}

.radioButton-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0;
}

.el-radio-group
  /deep/
  .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/screens/financeiro/relatoriosDae/components/AppRelatorioBase.vue